var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#D84C10",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.074 19.1504L30.243 19.1644L30.403 19.1904L30.49 19.2094C30.682 19.2554 30.817 19.3174 31.121 19.4844L38.812 23.7574L39.044 23.8924C39.2043 23.9844 39.3488 24.1016 39.472 24.2394C39.6649 24.4488 39.8108 24.697 39.9 24.9674C39.961 25.1534 39.986 25.2804 39.995 25.5084L40 25.7764V34.0644L39.994 34.5034C39.9915 34.6276 39.9764 34.7512 39.949 34.8724L39.899 35.0444C39.8096 35.3152 39.6633 35.5638 39.47 35.7734C39.337 35.9174 39.238 36.0004 39.043 36.1194L38.811 36.2544L31.262 40.4484L31 40.5914L30.805 40.6894C30.6772 40.7501 30.5421 40.7941 30.403 40.8204C30.137 40.8754 29.862 40.8754 29.597 40.8204L29.431 40.7804C29.328 40.7504 29.233 40.7114 29.103 40.6454L28.878 40.5264L21.337 36.3374L20.984 36.1364L20.873 36.0654L20.772 35.9924C20.683 35.9254 20.603 35.8534 20.529 35.7734C20.3361 35.564 20.1902 35.3158 20.101 35.0454C20.04 34.8594 20.015 34.7324 20.006 34.5044L20 34.2354L20.001 25.6494C20.007 25.3554 20.029 25.1834 20.1 24.9674C20.1892 24.697 20.3351 24.4488 20.528 24.2394C20.661 24.0954 20.76 24.0124 20.955 23.8934L21.187 23.7584L29 19.4194C29.261 19.2804 29.384 19.2344 29.597 19.1904C29.7031 19.1687 29.8108 19.1557 29.919 19.1514L30.074 19.1504ZM22 26.7054L22.001 34.4134L28.999 38.3054V30.5934L22 26.7054ZM37.999 26.7054L30.999 30.5934V38.3034L37.998 34.4174L37.999 26.7054ZM29.997 21.1524L23.058 25.0054L29.999 28.8614L36.939 25.0054L30.14 21.2284L30.038 21.1664C30.027 21.1564 30.038 21.1564 30.067 21.1614L29.997 21.1524Z",
    fill: "#D84C10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBox);
export default __webpack_public_path__ + "static/media/icon_box.60a550be73ea092f09dcbdb37cb61f4e.svg";
export { ForwardRef as ReactComponent };